/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetParams,
  ListWorkshopsV1PulseWorkshopsGetParams,
  PulseAnalysis,
  PulsePublicWorkshopResponse,
  PulseReportResponse,
  PulseSubmissionCreate,
  PulseSubmissionInclusionUpdate,
  PulseSubmissionListResponse,
  PulseSubmissionReceipt,
  PulseSubmissionResponse,
  PulseWorkshopCreate,
  PulseWorkshopListResponse,
  PulseWorkshopResponse,
  PulseWorkshopUpdate
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * @summary Get Public Workshop
 */
export const getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet = (
    organizationSlug: string,
    workshopKey: string,
 signal?: AbortSignal
) => {


      return customInstance<PulsePublicWorkshopResponse>(
      {url: `/v1/pulse/public/${organizationSlug}/${workshopKey}`, method: 'GET', signal
    },
      );
    }




export const getGetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGetQueryKey = (organizationSlug?: string,
    workshopKey?: string,) => {
    return [
    `/v1/pulse/public/${organizationSlug}/${workshopKey}`
    ] as const;
    }


export const getGetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGetQueryOptions = <TData = Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError = HTTPValidationError>(organizationSlug: string,
    workshopKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGetQueryKey(organizationSlug,workshopKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>> = ({ signal }) => getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet(organizationSlug,workshopKey, signal);





   return  { queryKey, queryFn, enabled: !!(organizationSlug && workshopKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>>
export type GetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGetQueryError = HTTPValidationError


export function useGetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet<TData = Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError = HTTPValidationError>(
 organizationSlug: string,
    workshopKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>,
          TError,
          Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet<TData = Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError = HTTPValidationError>(
 organizationSlug: string,
    workshopKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>,
          TError,
          Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet<TData = Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError = HTTPValidationError>(
 organizationSlug: string,
    workshopKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Public Workshop
 */

export function useGetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet<TData = Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError = HTTPValidationError>(
 organizationSlug: string,
    workshopKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPublicWorkshopV1PulsePublicOrganizationSlugWorkshopKeyGetQueryOptions(organizationSlug,workshopKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create Public Submission
 */
export const createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost = (
    organizationSlug: string,
    workshopKey: string,
    pulseSubmissionCreate: PulseSubmissionCreate,
 signal?: AbortSignal
) => {


      return customInstance<PulseSubmissionReceipt>(
      {url: `/v1/pulse/public/${organizationSlug}/${workshopKey}/submissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pulseSubmissionCreate, signal
    },
      );
    }



export const getCreatePublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost>>, TError,{organizationSlug: string;workshopKey: string;data: PulseSubmissionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost>>, TError,{organizationSlug: string;workshopKey: string;data: PulseSubmissionCreate}, TContext> => {

const mutationKey = ['createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost>>, {organizationSlug: string;workshopKey: string;data: PulseSubmissionCreate}> = (props) => {
          const {organizationSlug,workshopKey,data} = props ?? {};

          return  createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost(organizationSlug,workshopKey,data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type CreatePublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost>>>
    export type CreatePublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPostMutationBody = PulseSubmissionCreate
    export type CreatePublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPostMutationError = HTTPValidationError

    /**
 * @summary Create Public Submission
 */
export const useCreatePublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost>>, TError,{organizationSlug: string;workshopKey: string;data: PulseSubmissionCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPost>>,
        TError,
        {organizationSlug: string;workshopKey: string;data: PulseSubmissionCreate},
        TContext
      > => {

      const mutationOptions = getCreatePublicSubmissionV1PulsePublicOrganizationSlugWorkshopKeySubmissionsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Create Workshop
 */
export const createWorkshopV1PulseWorkshopsPost = (
    pulseWorkshopCreate: PulseWorkshopCreate,
 signal?: AbortSignal
) => {


      return customInstance<PulseWorkshopResponse>(
      {url: `/v1/pulse/workshops`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pulseWorkshopCreate, signal
    },
      );
    }



export const getCreateWorkshopV1PulseWorkshopsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkshopV1PulseWorkshopsPost>>, TError,{data: PulseWorkshopCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorkshopV1PulseWorkshopsPost>>, TError,{data: PulseWorkshopCreate}, TContext> => {

const mutationKey = ['createWorkshopV1PulseWorkshopsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkshopV1PulseWorkshopsPost>>, {data: PulseWorkshopCreate}> = (props) => {
          const {data} = props ?? {};

          return  createWorkshopV1PulseWorkshopsPost(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkshopV1PulseWorkshopsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkshopV1PulseWorkshopsPost>>>
    export type CreateWorkshopV1PulseWorkshopsPostMutationBody = PulseWorkshopCreate
    export type CreateWorkshopV1PulseWorkshopsPostMutationError = HTTPValidationError

    /**
 * @summary Create Workshop
 */
export const useCreateWorkshopV1PulseWorkshopsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkshopV1PulseWorkshopsPost>>, TError,{data: PulseWorkshopCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkshopV1PulseWorkshopsPost>>,
        TError,
        {data: PulseWorkshopCreate},
        TContext
      > => {

      const mutationOptions = getCreateWorkshopV1PulseWorkshopsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List Workshops
 */
export const listWorkshopsV1PulseWorkshopsGet = (
    params?: ListWorkshopsV1PulseWorkshopsGetParams,
 signal?: AbortSignal
) => {


      return customInstance<PulseWorkshopListResponse>(
      {url: `/v1/pulse/workshops`, method: 'GET',
        params, signal
    },
      );
    }




export const getListWorkshopsV1PulseWorkshopsGetQueryKey = (params?: ListWorkshopsV1PulseWorkshopsGetParams,) => {
    return [
    `/v1/pulse/workshops`, ...(params ? [params]: [])
    ] as const;
    }


export const getListWorkshopsV1PulseWorkshopsGetQueryOptions = <TData = Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError = HTTPValidationError>(params?: ListWorkshopsV1PulseWorkshopsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkshopsV1PulseWorkshopsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>> = ({ signal }) => listWorkshopsV1PulseWorkshopsGet(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListWorkshopsV1PulseWorkshopsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>>
export type ListWorkshopsV1PulseWorkshopsGetQueryError = HTTPValidationError


export function useListWorkshopsV1PulseWorkshopsGet<TData = Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListWorkshopsV1PulseWorkshopsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>,
          TError,
          Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListWorkshopsV1PulseWorkshopsGet<TData = Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError = HTTPValidationError>(
 params?: ListWorkshopsV1PulseWorkshopsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>,
          TError,
          Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListWorkshopsV1PulseWorkshopsGet<TData = Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError = HTTPValidationError>(
 params?: ListWorkshopsV1PulseWorkshopsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Workshops
 */

export function useListWorkshopsV1PulseWorkshopsGet<TData = Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError = HTTPValidationError>(
 params?: ListWorkshopsV1PulseWorkshopsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopsV1PulseWorkshopsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListWorkshopsV1PulseWorkshopsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get Workshop
 */
export const getWorkshopV1PulseWorkshopsWorkshopIdGet = (
    workshopId: number,
 signal?: AbortSignal
) => {


      return customInstance<PulseWorkshopResponse>(
      {url: `/v1/pulse/workshops/${workshopId}`, method: 'GET', signal
    },
      );
    }




export const getGetWorkshopV1PulseWorkshopsWorkshopIdGetQueryKey = (workshopId?: number,) => {
    return [
    `/v1/pulse/workshops/${workshopId}`
    ] as const;
    }


export const getGetWorkshopV1PulseWorkshopsWorkshopIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError = HTTPValidationError>(workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkshopV1PulseWorkshopsWorkshopIdGetQueryKey(workshopId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>> = ({ signal }) => getWorkshopV1PulseWorkshopsWorkshopIdGet(workshopId, signal);





   return  { queryKey, queryFn, enabled: !!(workshopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkshopV1PulseWorkshopsWorkshopIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>>
export type GetWorkshopV1PulseWorkshopsWorkshopIdGetQueryError = HTTPValidationError


export function useGetWorkshopV1PulseWorkshopsWorkshopIdGet<TData = Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError = HTTPValidationError>(
 workshopId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkshopV1PulseWorkshopsWorkshopIdGet<TData = Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkshopV1PulseWorkshopsWorkshopIdGet<TData = Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Workshop
 */

export function useGetWorkshopV1PulseWorkshopsWorkshopIdGet<TData = Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopV1PulseWorkshopsWorkshopIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkshopV1PulseWorkshopsWorkshopIdGetQueryOptions(workshopId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update Workshop
 */
export const updateWorkshopV1PulseWorkshopsWorkshopIdPatch = (
    workshopId: number,
    pulseWorkshopUpdate: PulseWorkshopUpdate,
 ) => {


      return customInstance<PulseWorkshopResponse>(
      {url: `/v1/pulse/workshops/${workshopId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pulseWorkshopUpdate
    },
      );
    }



export const getUpdateWorkshopV1PulseWorkshopsWorkshopIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkshopV1PulseWorkshopsWorkshopIdPatch>>, TError,{workshopId: number;data: PulseWorkshopUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkshopV1PulseWorkshopsWorkshopIdPatch>>, TError,{workshopId: number;data: PulseWorkshopUpdate}, TContext> => {

const mutationKey = ['updateWorkshopV1PulseWorkshopsWorkshopIdPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkshopV1PulseWorkshopsWorkshopIdPatch>>, {workshopId: number;data: PulseWorkshopUpdate}> = (props) => {
          const {workshopId,data} = props ?? {};

          return  updateWorkshopV1PulseWorkshopsWorkshopIdPatch(workshopId,data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkshopV1PulseWorkshopsWorkshopIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkshopV1PulseWorkshopsWorkshopIdPatch>>>
    export type UpdateWorkshopV1PulseWorkshopsWorkshopIdPatchMutationBody = PulseWorkshopUpdate
    export type UpdateWorkshopV1PulseWorkshopsWorkshopIdPatchMutationError = HTTPValidationError

    /**
 * @summary Update Workshop
 */
export const useUpdateWorkshopV1PulseWorkshopsWorkshopIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkshopV1PulseWorkshopsWorkshopIdPatch>>, TError,{workshopId: number;data: PulseWorkshopUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkshopV1PulseWorkshopsWorkshopIdPatch>>,
        TError,
        {workshopId: number;data: PulseWorkshopUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateWorkshopV1PulseWorkshopsWorkshopIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete Workshop
 */
export const deleteWorkshopV1PulseWorkshopsWorkshopIdDelete = (
    workshopId: number,
 ) => {


      return customInstance<void>(
      {url: `/v1/pulse/workshops/${workshopId}`, method: 'DELETE'
    },
      );
    }



export const getDeleteWorkshopV1PulseWorkshopsWorkshopIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkshopV1PulseWorkshopsWorkshopIdDelete>>, TError,{workshopId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkshopV1PulseWorkshopsWorkshopIdDelete>>, TError,{workshopId: number}, TContext> => {

const mutationKey = ['deleteWorkshopV1PulseWorkshopsWorkshopIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkshopV1PulseWorkshopsWorkshopIdDelete>>, {workshopId: number}> = (props) => {
          const {workshopId} = props ?? {};

          return  deleteWorkshopV1PulseWorkshopsWorkshopIdDelete(workshopId,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkshopV1PulseWorkshopsWorkshopIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkshopV1PulseWorkshopsWorkshopIdDelete>>>

    export type DeleteWorkshopV1PulseWorkshopsWorkshopIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Workshop
 */
export const useDeleteWorkshopV1PulseWorkshopsWorkshopIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkshopV1PulseWorkshopsWorkshopIdDelete>>, TError,{workshopId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkshopV1PulseWorkshopsWorkshopIdDelete>>,
        TError,
        {workshopId: number},
        TContext
      > => {

      const mutationOptions = getDeleteWorkshopV1PulseWorkshopsWorkshopIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List Workshop Submissions
 */
export const listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet = (
    workshopId: number,
    params?: ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetParams,
 signal?: AbortSignal
) => {


      return customInstance<PulseSubmissionListResponse>(
      {url: `/v1/pulse/workshops/${workshopId}/submissions`, method: 'GET',
        params, signal
    },
      );
    }




export const getListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetQueryKey = (workshopId?: number,
    params?: ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetParams,) => {
    return [
    `/v1/pulse/workshops/${workshopId}/submissions`, ...(params ? [params]: [])
    ] as const;
    }


export const getListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetQueryOptions = <TData = Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError = HTTPValidationError>(workshopId: number,
    params?: ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetQueryKey(workshopId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>> = ({ signal }) => listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet(workshopId,params, signal);





   return  { queryKey, queryFn, enabled: !!(workshopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>>
export type ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetQueryError = HTTPValidationError


export function useListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet<TData = Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError = HTTPValidationError>(
 workshopId: number,
    params: undefined |  ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>,
          TError,
          Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet<TData = Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError = HTTPValidationError>(
 workshopId: number,
    params?: ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>,
          TError,
          Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet<TData = Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError = HTTPValidationError>(
 workshopId: number,
    params?: ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Workshop Submissions
 */

export function useListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet<TData = Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError = HTTPValidationError>(
 workshopId: number,
    params?: ListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListWorkshopSubmissionsV1PulseWorkshopsWorkshopIdSubmissionsGetQueryOptions(workshopId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update Workshop Submission
 */
export const updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch = (
    workshopId: number,
    submissionId: number,
    pulseSubmissionInclusionUpdate: PulseSubmissionInclusionUpdate,
 ) => {


      return customInstance<PulseSubmissionResponse>(
      {url: `/v1/pulse/workshops/${workshopId}/submissions/${submissionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pulseSubmissionInclusionUpdate
    },
      );
    }



export const getUpdateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch>>, TError,{workshopId: number;submissionId: number;data: PulseSubmissionInclusionUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch>>, TError,{workshopId: number;submissionId: number;data: PulseSubmissionInclusionUpdate}, TContext> => {

const mutationKey = ['updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch>>, {workshopId: number;submissionId: number;data: PulseSubmissionInclusionUpdate}> = (props) => {
          const {workshopId,submissionId,data} = props ?? {};

          return  updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch(workshopId,submissionId,data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch>>>
    export type UpdateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatchMutationBody = PulseSubmissionInclusionUpdate
    export type UpdateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatchMutationError = HTTPValidationError

    /**
 * @summary Update Workshop Submission
 */
export const useUpdateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch>>, TError,{workshopId: number;submissionId: number;data: PulseSubmissionInclusionUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatch>>,
        TError,
        {workshopId: number;submissionId: number;data: PulseSubmissionInclusionUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateWorkshopSubmissionV1PulseWorkshopsWorkshopIdSubmissionsSubmissionIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get Workshop Analysis
 */
export const getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet = (
    workshopId: number,
 signal?: AbortSignal
) => {


      return customInstance<PulseAnalysis>(
      {url: `/v1/pulse/workshops/${workshopId}/analysis`, method: 'GET', signal
    },
      );
    }




export const getGetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGetQueryKey = (workshopId?: number,) => {
    return [
    `/v1/pulse/workshops/${workshopId}/analysis`
    ] as const;
    }


export const getGetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGetQueryOptions = <TData = Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError = HTTPValidationError>(workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGetQueryKey(workshopId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>> = ({ signal }) => getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet(workshopId, signal);





   return  { queryKey, queryFn, enabled: !!(workshopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGetQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>>
export type GetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGetQueryError = HTTPValidationError


export function useGetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet<TData = Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError = HTTPValidationError>(
 workshopId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet<TData = Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet<TData = Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Workshop Analysis
 */

export function useGetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet<TData = Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkshopAnalysisV1PulseWorkshopsWorkshopIdAnalysisGetQueryOptions(workshopId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get Workshop Report
 */
export const getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet = (
    workshopId: number,
 signal?: AbortSignal
) => {


      return customInstance<PulseReportResponse>(
      {url: `/v1/pulse/workshops/${workshopId}/report`, method: 'GET', signal
    },
      );
    }




export const getGetWorkshopReportV1PulseWorkshopsWorkshopIdReportGetQueryKey = (workshopId?: number,) => {
    return [
    `/v1/pulse/workshops/${workshopId}/report`
    ] as const;
    }


export const getGetWorkshopReportV1PulseWorkshopsWorkshopIdReportGetQueryOptions = <TData = Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError = HTTPValidationError>(workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkshopReportV1PulseWorkshopsWorkshopIdReportGetQueryKey(workshopId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>> = ({ signal }) => getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet(workshopId, signal);





   return  { queryKey, queryFn, enabled: !!(workshopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkshopReportV1PulseWorkshopsWorkshopIdReportGetQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>>
export type GetWorkshopReportV1PulseWorkshopsWorkshopIdReportGetQueryError = HTTPValidationError


export function useGetWorkshopReportV1PulseWorkshopsWorkshopIdReportGet<TData = Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError = HTTPValidationError>(
 workshopId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkshopReportV1PulseWorkshopsWorkshopIdReportGet<TData = Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkshopReportV1PulseWorkshopsWorkshopIdReportGet<TData = Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Workshop Report
 */

export function useGetWorkshopReportV1PulseWorkshopsWorkshopIdReportGet<TData = Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopReportV1PulseWorkshopsWorkshopIdReportGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkshopReportV1PulseWorkshopsWorkshopIdReportGetQueryOptions(workshopId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Generate Workshop Report
 */
export const generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost = (
    workshopId: number,
 signal?: AbortSignal
) => {


      return customInstance<PulseReportResponse>(
      {url: `/v1/pulse/workshops/${workshopId}/report`, method: 'POST', signal
    },
      );
    }



export const getGenerateWorkshopReportV1PulseWorkshopsWorkshopIdReportPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost>>, TError,{workshopId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost>>, TError,{workshopId: number}, TContext> => {

const mutationKey = ['generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost>>, {workshopId: number}> = (props) => {
          const {workshopId} = props ?? {};

          return  generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost(workshopId,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type GenerateWorkshopReportV1PulseWorkshopsWorkshopIdReportPostMutationResult = NonNullable<Awaited<ReturnType<typeof generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost>>>

    export type GenerateWorkshopReportV1PulseWorkshopsWorkshopIdReportPostMutationError = HTTPValidationError

    /**
 * @summary Generate Workshop Report
 */
export const useGenerateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost>>, TError,{workshopId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateWorkshopReportV1PulseWorkshopsWorkshopIdReportPost>>,
        TError,
        {workshopId: number},
        TContext
      > => {

      const mutationOptions = getGenerateWorkshopReportV1PulseWorkshopsWorkshopIdReportPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Download Workshop Report
 */
export const downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet = (
    workshopId: number,
 signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/v1/pulse/workshops/${workshopId}/report.html`, method: 'GET', signal
    },
      );
    }




export const getDownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGetQueryKey = (workshopId?: number,) => {
    return [
    `/v1/pulse/workshops/${workshopId}/report.html`
    ] as const;
    }


export const getDownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError = HTTPValidationError>(workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGetQueryKey(workshopId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>> = ({ signal }) => downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet(workshopId, signal);





   return  { queryKey, queryFn, enabled: !!(workshopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>>
export type DownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGetQueryError = HTTPValidationError


export function useDownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet<TData = Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError = HTTPValidationError>(
 workshopId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>,
          TError,
          Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet<TData = Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>,
          TError,
          Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet<TData = Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download Workshop Report
 */

export function useDownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet<TData = Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError = HTTPValidationError>(
 workshopId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDownloadWorkshopReportV1PulseWorkshopsWorkshopIdReportHtmlGetQueryOptions(workshopId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Close Workshop
 */
export const closeWorkshopV1PulseWorkshopsWorkshopIdClosePost = (
    workshopId: number,
 signal?: AbortSignal
) => {


      return customInstance<PulseWorkshopResponse>(
      {url: `/v1/pulse/workshops/${workshopId}/close`, method: 'POST', signal
    },
      );
    }



export const getCloseWorkshopV1PulseWorkshopsWorkshopIdClosePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeWorkshopV1PulseWorkshopsWorkshopIdClosePost>>, TError,{workshopId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof closeWorkshopV1PulseWorkshopsWorkshopIdClosePost>>, TError,{workshopId: number}, TContext> => {

const mutationKey = ['closeWorkshopV1PulseWorkshopsWorkshopIdClosePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeWorkshopV1PulseWorkshopsWorkshopIdClosePost>>, {workshopId: number}> = (props) => {
          const {workshopId} = props ?? {};

          return  closeWorkshopV1PulseWorkshopsWorkshopIdClosePost(workshopId,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type CloseWorkshopV1PulseWorkshopsWorkshopIdClosePostMutationResult = NonNullable<Awaited<ReturnType<typeof closeWorkshopV1PulseWorkshopsWorkshopIdClosePost>>>

    export type CloseWorkshopV1PulseWorkshopsWorkshopIdClosePostMutationError = HTTPValidationError

    /**
 * @summary Close Workshop
 */
export const useCloseWorkshopV1PulseWorkshopsWorkshopIdClosePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeWorkshopV1PulseWorkshopsWorkshopIdClosePost>>, TError,{workshopId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeWorkshopV1PulseWorkshopsWorkshopIdClosePost>>,
        TError,
        {workshopId: number},
        TContext
      > => {

      const mutationOptions = getCloseWorkshopV1PulseWorkshopsWorkshopIdClosePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reopen Workshop
 */
export const reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost = (
    workshopId: number,
 signal?: AbortSignal
) => {


      return customInstance<PulseWorkshopResponse>(
      {url: `/v1/pulse/workshops/${workshopId}/reopen`, method: 'POST', signal
    },
      );
    }



export const getReopenWorkshopV1PulseWorkshopsWorkshopIdReopenPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost>>, TError,{workshopId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost>>, TError,{workshopId: number}, TContext> => {

const mutationKey = ['reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost>>, {workshopId: number}> = (props) => {
          const {workshopId} = props ?? {};

          return  reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost(workshopId,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type ReopenWorkshopV1PulseWorkshopsWorkshopIdReopenPostMutationResult = NonNullable<Awaited<ReturnType<typeof reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost>>>

    export type ReopenWorkshopV1PulseWorkshopsWorkshopIdReopenPostMutationError = HTTPValidationError

    /**
 * @summary Reopen Workshop
 */
export const useReopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost>>, TError,{workshopId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenWorkshopV1PulseWorkshopsWorkshopIdReopenPost>>,
        TError,
        {workshopId: number},
        TContext
      > => {

      const mutationOptions = getReopenWorkshopV1PulseWorkshopsWorkshopIdReopenPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Rotate Workshop Link
 */
export const rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost = (
    workshopId: number,
 signal?: AbortSignal
) => {


      return customInstance<PulseWorkshopResponse>(
      {url: `/v1/pulse/workshops/${workshopId}/rotate-link`, method: 'POST', signal
    },
      );
    }



export const getRotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost>>, TError,{workshopId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost>>, TError,{workshopId: number}, TContext> => {

const mutationKey = ['rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost>>, {workshopId: number}> = (props) => {
          const {workshopId} = props ?? {};

          return  rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost(workshopId,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type RotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPostMutationResult = NonNullable<Awaited<ReturnType<typeof rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost>>>

    export type RotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPostMutationError = HTTPValidationError

    /**
 * @summary Rotate Workshop Link
 */
export const useRotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost>>, TError,{workshopId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPost>>,
        TError,
        {workshopId: number},
        TContext
      > => {

      const mutationOptions = getRotateWorkshopLinkV1PulseWorkshopsWorkshopIdRotateLinkPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
